import { PrepJobResponse } from "@deliverr/prep-service-client";

export const checkIfPrepJobIsCompleted = (prepJob: PrepJobResponse): boolean => {
  return Boolean(prepJob.completedAt);
};
